export { ActivitiesNotificationComponent } from './activities-notification.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-notification/index.ts